import { render } from "./ModalCloseButton.vue?vue&type=template&id=74d779e5&scoped=true&lang=pug"
import script from "./ModalCloseButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalCloseButton.vue?vue&type=script&setup=true&lang=js"

import "./ModalCloseButton.vue?vue&type=style&index=0&id=74d779e5&scoped=true&lang=css"

import exportComponent from "/Users/liu/Downloads/开发程序/bridge v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74d779e5"]])

export default __exports__